<p>buy-now works!</p>
